import {Injectable} from '@angular/core';
import {Observable, Subject, from} from 'rxjs';


@Injectable()
export class EventsService {
	public listeners: any;
	public eventsSubject: any;
	public events: any;
	
	constructor() {
		var me = this;
		
		me.listeners = {};
		me.eventsSubject = new Subject();
		me.events = from(this.eventsSubject);
		
		me.events.subscribe(({name, args}) => {
			if (me.listeners[name]) {
				for (let listener of me.listeners[name]) {
					listener(...args);
				}
			}
		});
	}
	
	on(name, listener) {
		if (!this.listeners[name]) this.listeners[name] = [];
		
		this.listeners[name].push(listener);
		
		return this;
	}
	
	broadcast(name, ...args) {
		this.eventsSubject.next({name, args});
	}
	
	off(name) {
		delete this.listeners[name];
		
		return this;
	}
}
